import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];

  open(event) {
    event.preventDefault();
    this.containerTarget.classList.remove("hidden");
  }

  close() {
    this.containerTarget.classList.add("hidden");
  }
}
